import { render, staticRenderFns } from "./backup.vue?vue&type=template&id=3234fbed&scoped=true"
import script from "./backup.vue?vue&type=script&lang=js"
export * from "./backup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3234fbed",
  null
  
)

export default component.exports